import axios from 'axios';
import { ConfigFile as Config } from '@/Config';


const BaseStore = axios.create({
    baseURL: Config.serverHost,
    timeout: Config.requestTimeout,

    headers: {
        'Content-Type': 'application/json',
    }
});

export const DownloadStore = axios.create({
    baseURL: Config.serverHost,
    timeout: Config.requestTimeout * 10,

    headers: {
        'Content-Type': 'application/json',
    }
});


export default BaseStore;
